import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SHOP_ITEMS } from "../data/site";

export default function StudioMerch() {
  return (
    <section
      className="border-t border-[hsl(var(--rule))] bg-foreground text-background"
      data-testid="studio-merch"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-[1.1fr_2fr] gap-10 md:gap-20 items-end mb-10 md:mb-14">
          <div>
            <p className="label mb-3 text-background/60">Studio Merch</p>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Black Cowboys <em className="italic">Exist</em>.
            </h2>
          </div>
          <p className="text-background/75 max-w-prose md:mt-0 mt-2 text-base md:text-lg leading-relaxed">
            Wear the movement. A small line of studio merch — hats, tees,
            patches, and stickers — cut in the same colors as the paintings.
            Every purchase supports the studio and the story it&apos;s still writing.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-background/15">
          {SHOP_ITEMS.filter((s) => s.group === "Black Cowboys Exist").map(
            (s, idx) => (
            <a
              key={s.href}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-foreground p-6 md:p-8 min-h-[180px] md:min-h-[220px] flex flex-col justify-between hover:bg-[hsl(var(--accent))] transition-colors duration-500"
              data-testid={`merch-tile-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="label text-background/50 group-hover:text-background/80">
                No. {String(idx + 1).padStart(2, "0")}
              </span>
              <div>
                <p className="serif text-2xl md:text-3xl leading-[1.05] tracking-tight">
                  {s.label}
                </p>
                <div className="mt-4 flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-background/70 group-hover:text-background">
                  <span>Shop the collective</span>
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 md:mt-10 flex items-center justify-between gap-4 text-background/60 text-xs uppercase tracking-[0.18em]">
          <span>Ships worldwide via Graves Collective</span>
          <a
            href="https://gravescollective.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 hover:text-background"
            data-testid="merch-see-all"
          >
            See the full collective →
          </a>
        </div>
      </div>
    </section>
  );
}
